import {
  Dispatch,
  FC,
  SetStateAction,
  useEffect,
  useMemo,
  useState,
} from "react";
import {
  ResizableHandle,
  ResizablePanel,
  ResizablePanelGroup,
} from "./ui/resizable";
import Question from "./Question";
import InterviewTabs from "./InterviewTabs";
import { OrgDetailsType } from "@/utils/feedbackBadges";
import { feedbackTabs } from "./tabs";
import { MicOpts } from "@/utils/types";
import { useAppContext } from "@/appContext";
import { formatTime } from "@/utils/utils";
import SessionCompletePage from "./SessionComplete";

interface Props {
  displayPastFeedback: boolean;
  retryClick?: () => void;
  nextClick?: () => void;
  newQuestionClick?: (ind: number) => void;
  org?: OrgDetailsType;
  adminView?: boolean;
  micOpts?: MicOpts;
  setShowLoader?: Dispatch<SetStateAction<boolean>>;
  recognizer?: any;
  timerOn?: boolean;
  synthesizeSpeech?: (text: string) => Promise<void>;
}

const ResizeFeedback: FC<Props> = ({
  displayPastFeedback,
  retryClick,
  nextClick,
  newQuestionClick,
  adminView,
  org,
  micOpts,
  setShowLoader,
  recognizer,
  timerOn,
  synthesizeSpeech,
}) => {
  const { state, reducers } = useAppContext();

  const [tabs, settabs] = useState<any[]>([]);
  const [isInterview, setisInterview] = useState<boolean>(true);
  const [sessionCompleteClick, setSessionCompleteClick] =
    useState<boolean>(false);

  useEffect(() => {
    setisInterview(state.session[state.currentQuestion]?.feedback === "");
  }, [state.currentQuestion, state.session]);

  useEffect(() => {
    if (state.session[state.currentQuestion]?.feedback === "") {
      settabs([feedbackTabs[0]]);
    } else if (adminView) {
      settabs([feedbackTabs[0], feedbackTabs[1]]);
    } else if (displayPastFeedback) {
      settabs([feedbackTabs[0], feedbackTabs[1], feedbackTabs[2]]);
    } else settabs(feedbackTabs);
  }, [adminView, isInterview, displayPastFeedback]);

  const handleOptionClick = (userresp: string, resp: string) => {
    let prompt1 = [...state.session[state.currentQuestion].prompt];
    prompt1.push({ role: "user", content: userresp });
    reducers.setinterviewer(resp);
    prompt1.push({ role: "assistant", content: resp });
    reducers.updatesession({ prompt: prompt1 });
    reducers.setcontextLength(
      state.contextLength + resp.split(" ").length + userresp.split(" ").length
    );
    if (synthesizeSpeech) {
      synthesizeSpeech(resp);
    }
  };

  return (
    <>
      {!sessionCompleteClick && (
        <ResizablePanelGroup direction="horizontal" className="w-full">
          <ResizablePanel defaultSize={50} minSize={25}>
            <div>
              <Question
                newQuestionClick={
                  newQuestionClick
                    ? (ind: number) => newQuestionClick(ind)
                    : () => { }
                }
                org={org}
                timerOn={timerOn}
                isInterview={isInterview}
                options={state.session[state.currentQuestion]?.biteSizeOptions}
                handleOptionClick={handleOptionClick}
                time={formatTime(
                  state?.session?.at(state.currentQuestion)?.time || 0
                )}
              />
            </div>
          </ResizablePanel>
          <ResizableHandle />
          <ResizablePanel defaultSize={50} minSize={50}>
            <InterviewTabs
              tabs={tabs}
              bottomButtons={{
                displayPastFeedback,
                nextClick,
                retryClick,
                sessionCompleteClick: () => setSessionCompleteClick(true),
              }}
              adminView={adminView}
              isInterview={isInterview}
              micOpts={micOpts}
              setShowLoader={setShowLoader}
              recognizer={recognizer}
            />
          </ResizablePanel>
        </ResizablePanelGroup>
      )}
      {sessionCompleteClick && <SessionCompletePage />}
    </>
  );
};

export default ResizeFeedback;
